import React, { Fragment } from 'react'

// icons
import { faBars } from '@fortawesome/free-solid-svg-icons'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import ItemFamiliaEliminada from './ItemFamiliaEliminada'

// route
import { withRouter } from 'react-router-dom'
import routes from '../../Routes'
import Header from '../Header/Header'
import usePagination from './hooks/usePagination'
import HeaderPagination from '../Custom/HeaderPagination'
import HeaderActionsButtons from '../Custom/HeaderActionsButtons'

const visibleButtons = {
    create: false,
    import: false,
    export: false,
    deleted: false,
    search: true,
}

function FamiliaEliminada({ history }) {
    const {
        handleBuscador,
        previousPage,
        totalPage,
        totalRegister,
        nextPage,
        page,
        familias,
        setIsLoad,
    } = usePagination(history, false)

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faBars} title={'Familias Eliminadas'} />
                </div>

                <HeaderActionsButtons
                    history={history}
                    routes={routes.FAMILIA}
                    visibleButtons={visibleButtons}
                    handleBuscador={handleBuscador}
                />

                <HeaderPagination
                    page={page}
                    totalPage={totalPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    totalRegister={totalRegister}
                />

                <table className="table table-striped mt-3 text-center">
                    <thead>
                        <tr>
                            <th scope="col">Id</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">Ganancia</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {familias.map((familia) => (
                            <ItemFamiliaEliminada
                                key={parseInt(familia.id)}
                                familia={familia}
                                setIsLoad={setIsLoad}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
}

export default withRouter(FamiliaEliminada)
